import { css } from '@emotion/react';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { useGlobalState } from '~src/global-state';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

import { returnAndExchangeMessagesBuilder } from './return-exchange-messages-builder';

export const ReturnAndExchange = () => {
  const globalState = useGlobalState();
  const { tICU } = useTranslations();

  const returnsPromise = globalState.returns_promise;

  if (returnsPromise === undefined || returnsPromise?.is_unavailable) {
    return null;
  }

  const hasReturnPolicyData = returnsPromise.return_policy_url && returnsPromise.return_policy_text;

  const returnOptions = returnAndExchangeMessagesBuilder(tICU, returnsPromise);

  return (
    <div css={styles.container}>
      <span css={styles.header}>{tICU('widget.EXCHANGE_AND_RETURN.TITLE')}</span>
      <div css={styles.exchangeContainer}>
        <ul css={styles.returnPromiseTable}>
          {returnOptions.map(option => (
            <li key={option}>
              <span>{option}</span>
            </li>
          ))}
        </ul>
        {hasReturnPolicyData && (
          <div css={styles.link}>
            <a
              css={{ textDecoration: 'none' }}
              href={returnsPromise.return_policy_url}
              target="_noopener"
            >
              <span css={styles.linkText}>{returnsPromise.return_policy_text}</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px',
    marginBottom: '24px',
  }),
  header: css({
    ...fontStyles.px16_20,
  }),
  exchangeContainer: css({
    backgroundColor: colors.neutral94,
    borderRadius: '6px',
    padding: '12px',
    marginTop: '12px',
    ...fontStyles.px14_20,
  }),
  returnPromiseTable: css({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    margin: 0,
    paddingLeft: '24px',
  }),
  link: css({
    paddingLeft: '24px',
    marginTop: '8px',
  }),
  linkText: css({
    borderBottom: `1px solid ${colors.black}`,
  }),
};
